import React, { memo } from 'react';

import { arrayIntoChunks } from 'utils/happyFunctions';

import messages from './Messages';
import { IUserSignatureInfo, UserSignaturesType } from './SignaturesPart';
import {
  SignatureBox,
  SignatureImage,
  WithoutSignature,
  SignatureOwnerRole,
  SignatureOwnerName,
} from './styles';
import Badge from '../../../../../../components/Badge/Badge';

interface IComponentProps {
  title: UserSignaturesType;
  signatures: IUserSignatureInfo[];
}

const generateExtraTD = (arrayLength: number) => {
  const size = 5 - (arrayLength % 5);
  return [...Array(size)].map((_c, index) => <td key={`extraTD_${index}`} />);
};

const SignaturesBox: React.FC<IComponentProps> = ({ title, signatures }) => {
  const signaturesChunks = arrayIntoChunks(
    signatures.sort((a, b) => a.order - b.order),
    5
  );
  return (
    <>
      {signaturesChunks.map((chunk, rowIndex) => {
        // render extra td tags for fix table border
        const extraTD = chunk.length % 5 !== 0 ? chunk.length : null;
        return (
          <tr key={`${title}@row_${rowIndex}`}>
            {chunk.map((user, chunkIndex) => (
              <td key={`${title}@box_${chunkIndex}`}>
                <SignatureBox>
                  <div style={{ position: 'relative' }}>
                    {user.signature.url &&
                    user.signature.status === 'signed' ? (
                      <SignatureImage src={user.signature.url as string} />
                    ) : (
                      <WithoutSignature>
                        {messages.withoutSignature(user.signature.status)}
                      </WithoutSignature>
                    )}
                    {user.guest && (
                      <Badge
                        color="black"
                        style={{
                          position: 'absolute',
                          bottom: '2px',
                          left: '2px',
                        }}
                      >
                        {messages.guest}
                      </Badge>
                    )}
                  </div>
                  <SignatureOwnerName isLarge={user.name.length > 18}>
                    <span>{user.name}</span>
                  </SignatureOwnerName>
                  <SignatureOwnerRole isLarge={user.role.length > 18}>
                    <span>{user.role}</span>
                  </SignatureOwnerRole>
                </SignatureBox>
              </td>
            ))}
            {extraTD && generateExtraTD(extraTD)}
          </tr>
        );
      })}
    </>
  );
};

export default memo(SignaturesBox);
